import { render, staticRenderFns } from "./ContactTracingStatisticView.vue?vue&type=template&id=ec13a736&"
import script from "./ContactTracingStatisticView.vue?vue&type=script&lang=js&"
export * from "./ContactTracingStatisticView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports